export enum ChematCustomerTypeSalePrice {
  PC1 = 1,
  PC2 = 2,
  PC3 = 3,
}
